module.exports = __webpack_public_path__ + "static/media/step2-2.e9385015.png";